@if (formGroup) {
  <form [formGroup]="formGroup" class="edit_document_fileNameField mb-4">
    <div class="documentname_regex">
      @for (field of documentNumberForm; track field; let i = $index) {
        <div>
          @if (field.fieldType === 'Sequence') {
            <div style="width: 130px;">
              <app-input-filed [value]="formGroup.value?.[field._id]"
              [control]="$any(formGroup).controls[field._id]" placeholder="Sequence"></app-input-filed>
            </div>
          }
          @if (field.fieldType === 'RS') {
            <div style="width: 130px;">
              <app-input-filed [value]="formGroup.value?.[field._id]" [control]="$any(formGroup).controls[field._id]"
              [maxlength]="field.len" [minlength]="field.len" placeholder="String"></app-input-filed>
              @if (formGroup.controls?.[field._id]?.errors?.['minlength']) {
                <div>
                  <small class="text-danger">The Value of RS should be {{ field.len }}.</small>
                </div>
              }
            </div>
          }
          @if (field.fieldType === 'YY') {
            <div style="width: 130px;">
              <app-input-filed [value]="formGroup.value?.[field._id]"
                [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
              maxlength="2"></app-input-filed>
            </div>
          }
          @if (field.fieldType === 'YYYY') {
            <div style="width: 130px;">
              <app-input-filed [value]="formGroup.value?.[field._id]"
                [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
              maxlength="4" [max]="prasentYear"></app-input-filed>
              @if (formGroup.controls?.[field._id]?.errors?.['max']) {
                <div>
                  <small class="text-danger">The Value of {{field.fieldType}} should not be greater than {{ prasentYear }}.</small>
                </div>
              }
            </div>
          }
          @if (field.fieldType === 'Static') {
            <div style="width: 130px;">
              <app-input-filed [readonly]="true" [value]="field.value"
              [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"></app-input-filed>
            </div>
          }
          @if (field.fieldType === 'DDMMYYYY') {
            <div class="filterOffcanvas__calenderbody">
              <div class="filterOffcanvas__calenderWrapper">
                <input type="date" [max]="ddmmyyyyy" [ngModel] ="(field.value?field.value:ddmmyyyyy) | date:'yyyy-MM-dd'" placeholder="DDMMYYYY"
                  class="custom-date-input form-control filterOffcanvas__inputlabel"
                  [formControl]="$any(formGroup).controls[field._id]" style="border: none" />
                </div>
              </div>
            }
            @if (field.fieldType === 'DDMMYY') {
              <div class="filterOffcanvas__calenderbody">
                <div class="filterOffcanvas__calenderWrapper">
                  <input type="date" [max]="ddmmyy" [ngModel] ="(field.value?field.value:ddmmyy) | date:'yyyy-MM-dd'" placeholder="DDMMYY"
                    class="custom-date-input form-control filterOffcanvas__inputlabel"
                    [formControl]="$any(formGroup).controls[field._id]" style="border: none" />
                  </div>
                </div>
              }
              @if (field.fieldType === 'MM') {
                <div style="margin-top: -17px;">
                  <div class="documentType__dropdown">
                    <select class="docType__dropdownOptions_mm" [formControl]="$any(formGroup).controls[field._id]">
                      <option value="MM" disabled selected>MM</option>
                      @for (item of daysMonths; track item; let i = $index) {
                        @if (i<12) {
                          <option [ngValue]="item">
                            {{ item }}
                          </option>
                        }
                      }
                    </select>
                  </div>
                </div>
              }
              @if (field.fieldType === 'DD') {
                <div style="margin-top: -17px;">
                  <div class="documentType__dropdown">
                    <select class="docType__dropdownOptions_mm" [formControl]="$any(formGroup).controls[field._id]">
                      <option value="DD" disabled selected>DD</option>
                      @for (item of daysMonths; track item) {
                        <option [ngValue]="item">
                          {{ item }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (field.fieldType === 'Numeric') {
                <div style="width: 130px;">
                  <app-input-filed [value]="formGroup.value?.[field._id]"
                    [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
                  type="number"></app-input-filed>
                  @if (formGroup.controls?.[field._id]?.invalid &&
                    (formGroup.controls?.[field._id]?.dirty ||
                    formGroup.controls?.[field._id]?.touched)) {
                    <div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="barcode-message">
          <small class="text-danger">{{showErrorMessage()}}</small>
        </div>
        @if (metaData?.length) {
          <div>
            @for (field of metaData; track field) {
              <div class="mt-3">
                @if (field.fieldType === 'Text') {
                  <div>
                    <app-input-filed [value]="formGroup.value?.[field._id]" label="{{field.label}}"
                      [control]="$any(formGroup).controls[field._id]" starIcon="{{field.validateRequire?'*':''}}"
                    placeholder="{{field.label}}"></app-input-filed>
                    @if (formGroup.controls?.[field._id]?.invalid &&
                      (formGroup.controls?.[field._id]?.dirty ||
                      formGroup.controls?.[field._id]?.touched)) {
                      <div>
                        @if (formGroup.controls?.[field._id]?.errors?.['required']) {
                          <div>
                            <small class="text-danger">{{field.label}} is required</small>
                            <small class="text-danger">{{field.len}} is required</small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (field.fieldType === 'TextArea') {
                  <div>
                    <app-description-field [DescriptionData]="field.label" class="pt-3"
                      [control]="$any(formGroup).controls[field._id]" starIcon="{{field.validateRequire?'*':''}}"
                    placeholder="{{field.label}}"></app-description-field>
                    @if (formGroup.controls?.[field._id]?.invalid &&
                      (formGroup.controls?.[field._id]?.dirty ||
                      formGroup.controls?.[field._id]?.touched)) {
                      <div>
                        @if (formGroup.controls?.[field._id]?.errors?.['required']) {
                          <div>
                            <small class="text-danger">{{ field.label }} is required.</small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (field.fieldType === 'Radio') {
                  <div>
                    <section class="editDocument__radioContainer">
                      <p class="editDocument__text1">{{ field.label }} @if (field.validateRequire) {
                        <span
                        class="spmred">*</span>
                      }</p>
                      <div class="editDocument__radioButtons">
                        @for (fieldVaue of field.fieldValues; track fieldVaue) {
                          <app-radiobutton
                            (checked)="handleDocumentTypeChange.emit({ value: fieldVaue, id: field._id })" value="{{fieldVaue}}"
                            radioText="{{fieldVaue}}"
                            [defaultCheck]="selectedFile?._id?getradioValue(fieldVaue, selectedFile?.metaData, field._id):fieldVaue === selectedFile?.metaData?.[field._id]">
                          </app-radiobutton>
                        }
                      </div>
                    </section>
                  </div>
                }
                @if (field.fieldType === 'CheckBox') {
                  <div>
                    <p class="editDocument__text1">{{ field.label }}</p>
                    @for (fieldvalue of field.fieldValues; track fieldvalue) {
                      <div class="toggle-button-text">
                        <div>
                          <app-checkbox class="editDocument__checkbox" className="labelWidth"
                            checkboxStatus="{{fieldvalue === selectedFile?.metaData?.[field._id]}}"
                            (checked)="handleDocumentTypeChange.emit({ value: fieldvalue, id: field._id })"
                          checkBoxName={{fieldvalue}}></app-checkbox>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (field.fieldType === 'Number') {
                  <div>
                    <app-input-filed [value]="formGroup.value?.[field._id]" label="{{field.label}}"
                      [control]="$any(formGroup).controls[field._id]" type="number"
                    starIcon="{{field.validateRequire?'*':''}}" placeholder="{{field.label}}"></app-input-filed>
                    @if (formGroup.controls?.[field._id]?.invalid &&
                      (formGroup.controls?.[field._id]?.dirty ||
                      formGroup.controls?.[field._id]?.touched)) {
                      <div>
                        @if (formGroup.controls?.[field._id]?.errors?.['required']) {
                          <div>
                            <small class="text-danger">{{ field.label }} is required.</small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </form>
    }
